import { useParams } from 'react-router-dom';
import { ExternalRedirect } from '../../helpers/getRedirectUrl';
import NEXT_ROUTES from '../../../next.routes';

function AssessmentPageCandidate() {
  const { id } = useParams();
  const targetUrl = `${NEXT_ROUTES.ASSESSMENT_META}${id}`;

  return <ExternalRedirect to={targetUrl} replace />;
}

export default AssessmentPageCandidate;
